import { combineReducers } from "redux";

import { authentication } from "./authentication.reducer";
import { registration } from "./registration.reducer";
import { users } from "./users.reducer";
import { alert } from "./alert.reducer";
import { redempProduct } from "./redempProduct.reducer";
import { shippingDetails } from "./shippingDetails.reducer";

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  redempProduct,
  shippingDetails
});

export default rootReducer;
